import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { GlobalLoaderComponent } from './global-loader/global-loader.component';
import { IFilterComponent } from './i-filter/i-filter.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NzIconModule,
    ReactiveFormsModule,
    NzFormModule,
    NzInputModule,
    NzButtonModule,
    NzDatePickerModule,
    NzSpinModule,
    NzSelectModule,
  ],
  declarations: [GlobalLoaderComponent, IFilterComponent],
  exports: [GlobalLoaderComponent, IFilterComponent],
})
export class ComponentsModule {}
